:host {
  display: flex;
  padding: 8px 16px;
}

:host(.text-message--bot) {
  background-color: var(--message-robot-background-color);
  color: var(--message-robot-color);
}
:host(.text-message--user) {
  background-color: var(--message-user-background-color);
  color: var(--message-user-color);
}
  